const matutaions = {
  SET_INNERS: (state, payload) => {
    state.submitForm.inners = payload.list;
  },
  SET_CHECKBOX_STAFF: (state, payload) => {
    state.checkboxStaff = payload.list;
  },
  SET_STAFF_IDS: (state, payload) => {
    state.staffIds = payload.list;
  },
  SET_OUTERS_IDS: (state, payload) => {
    state.outersIds = payload.list;
  },
  SET_OUTERS: (state, payload) => {
    state.submitForm.outers = payload.list;
  },
  SET_REQUIRES: (state, payload) => {
    state.submitForm.requires = payload.list;
    state.submitForm.requiresInfo = payload.info;
  },
  SET_REQUIRES_INFO: (state, payload) => {
    state.requiresInfo = payload.info;
  },
  SET_HOST_ID: (state, payload) => {
    state.hostId = payload.list;
  },
  SET_PARENT_ID: (state, payload) => {
    state.staffParentId = payload.id;
  },
  SET_HOST_PARENT_ID: (state, payload) => {
    state.hostParentId = payload.id;
  },
  SET_SELECT_STAFF_PARENT_ID: (state, payload) => {
    state.selectStaffParentId = payload.id;
  },
  SET_ORGANIZER: (state, payload) => {
    state.submitForm.organizer = payload.data.organizer;
    state.submitForm.organizerId = payload.data.organizerId;
    state.submitForm.organization = payload.data.company;
    state.submitForm.organizationId = payload.data.companyId;
  },
  SET_FORM: (state, payload) => {
    state.submitForm = payload.data;
  },
  SET_VOUCHER_APPLICATION_FORM: (state, payload) => {
    state.voucherApplicationForm = payload.data;
  },
  SET_MEAL_BOOK_FORM: (state, payload) => {
    state.mealBookForm = payload.data;
  },
  SET_BOOKING_LIMIT_TIME: (state, payload) => {
    state.bookingLimitTime = payload.data.bookingLimitTime;
    state.payType = payload.data.payType;
  },
  SET_ROOM_DATA: (state, payload) => {
    state.roomData = payload.data;
  },
  SET_FLOOR_INFO: (state, payload) => {
    state.floorInfo = payload.data;
  },
  SET_INVITE_DATA: (state, payload) => {
    state.inviteData = payload.data;
  },
  CLEAR_FORM: (state, payload) => {
    state.submitForm = {
      theme: '',
      visitDate: '',
      coOrganization: '',
      outsizeAttendeeCount: '',
      inners: [],
      outers: [],
      agendasList: [],
      materials: [],
      requires: [],
      requiresInfo: {
        dataForm: {},
        checkedList: []
      },
      organizer: '',
      organizerId: '',
      signType: 'ANYWAY_SIGN',
      signTime: '',
      starTime: '',
      endTime: '',
      meetingRoomId: '',
      meetingRoomName: '',
      ruleText: '手动签到/通行会议室门禁',
      ruleIndex: 0,
      meetingType: 'PRIVATE',
      meetingTypeText: '固定会议',
      pageStyle: 'blue',
      meetingTypeIndex: 0,
      organization: '',
      organizationId: ''
    };
    state.staffIds = []; // addstaff 页面缓存的ids
    state.hostId = []; // addhost 页面缓存的ids
    state.staffParentId = 0; // addstaff 页面缓存的ids
    state.hostParentId = 0; // addhost 页面缓存的ids
    state.outersIds = [];
    state.requiresInfo = {
      dataForm: {},
      checkedList: []
    };
  },
  CLEAR_VOUCHER_APPLICATION_FORM: (state) => {
    state.voucherApplicationForm = { // 申请卡券的form
      name: '',
      couponId: '',
      applyCount: '',
      receiptorId: '',
      applyReason: '',
      attachmentUrls: []
    };
  },
  CLEAR_MEAL_BOOK_FORM: (state) => {
    state.mealBookForm = {
      payText: '',
      zoneText: '',
      zoneIndex: '',
      payIndex: '',
      mealRuleId: '',
      bookingDate: '',
      payType: '',
      innerPersonIds: [],
      outerPersonNumber: 0,
      couponId: '',
      couponName: ''
    };
    state.checkboxStaff = [];
  },
  SET_DATE: (state, payload) => {
    state.meetingDate = payload.data;
  },
  SET_SELECT_STAFF_ID: (state, payload) => {
    state.selectStaffInfo = payload.data;
    state.selectStaffId = payload.data.id;
  },
  SET_COUPON_INFO: (state, payload) => {
    state.couponInfo = payload;
  },
  SET_INCLUDE_NAME: (state) => {
    state.includeName = ['StaffHistory', 'bind', 'MeetingBook', 'StaffMeetingHistory', 'Vouchers', 'MealBook', 'QrCode', 'qrCode', 'FaceAuth'];
  },
  CLEAR_INCLUDE_NAME: (state) => {
    state.includeName = ['bind', 'MeetingBook', 'StaffMeetingHistory', 'Vouchers', 'MealBook', 'QrCode', 'qrCode', 'FaceAuth'];
  }
};

export default matutaions;
